// extracted by mini-css-extract-plugin
export default {"container":"g1-z","list":"h1-z"};